import { useCallback } from 'react';
import { useFeatureFlag } from '@/store/slices/api/featureFlagsApiSlice';
import { routes } from '@/routes';

export const useTransmissionReportFeature = () => {
  const isTransmissionReportPageEnabled = useFeatureFlag('new-tx-report-page-v2');

  const getDefaultReportRoute = useCallback(() => {
    return isTransmissionReportPageEnabled
      ? routes.physician.defaultTransmissionReport
      : routes.physician.reviewTransmissions;
  }, [isTransmissionReportPageEnabled]);

  const getSpecificReportRoute = useCallback((id: string) => {
    return isTransmissionReportPageEnabled
      ? routes.physician.transmissionReportDetail(id)
      : routes.physician.reviewTransmission(id);
  }, [isTransmissionReportPageEnabled]);

  return {
    isTransmissionReportPageEnabled,
    getDefaultReportRoute,
    getSpecificReportRoute
  };
};